import { ReactNode } from 'react'
import { clsx } from '@mantine/styles'

import classes from './FilterChip.module.scss'

type FilterChipProps = {
  label: string
  onToggle: VoidFunction
  selected?: boolean
  icon?: ReactNode
  testId?: string
}

export function FilterChip({ label, onToggle, selected = false, icon, testId }: Readonly<FilterChipProps>) {
  return (
    <button
      className={clsx(classes.FilterChip, selected && classes.selected, !icon && classes.noIcon)}
      type="button"
      data-testid={testId}
      onClick={onToggle}
      aria-pressed={selected}
    >
      {icon && <span className={classes.icon}>{icon}</span>}
      {label}
    </button>
  )
}
